import {DetailPanel, DetailKvTable, DetailSummaryButton} from '../../../../components/detailLayout';
import React, {useState} from 'react';
import Th_title from "../../../../components/Th_title";
import {ExamineRadioAttributes} from "../../../../constant/RadioGroupAttributes";
import {ContentCategory, ContentStatus, ExamineType, UserIdType, UserType} from "../../../../constant/CodeSpecNum";
import TextAreaBasic from "../../../../components/input/TextAreaBasic";
import {changeStatusNumericValue} from "../../../../redux/slice/contentSlice";
import {
    updateAdjustOnExamine,
    updateExamineCloseDate,
    updateRejectOnExamine,
    updateTransferOnExamine
} from "../../../../api/serviceRequest/ServiceRequestService";
import {handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {useDispatch, useSelector} from "react-redux";
import {changeRefreshContentStatus} from "../../../../redux/slice/statusSlice";
import {handleValidation} from "../serviceUtils";
import {changeNextContentStatus} from "../../../../api/contentStatus/contentStatusService";
import {useTranslation} from "react-i18next";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import dayjs from "dayjs";
import {onCreateIdClickListener, onUpdate} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import SimmsTextArea from "../../../../components/input/SimmsTextArea";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import SimmsSelect from "../../../../components/select/SimmsSelect";

const EXAMINE_TYPE_PLACEHOLDER_ID = -1;
const EXAMINE_TYPE_OPTION_IDS = {
    [ExamineType.ADJUST]: 1,
    [ExamineType.TRANSFER]: 2,
    [ExamineType.REJECT]: 3,
};
const EXAMINE_TYPE_ID_TO_VALUE = {
    1: ExamineType.ADJUST,
    2: ExamineType.TRANSFER,
    3: ExamineType.REJECT,
};

const ServiceRequestExamine = ({serviceRequest}) => {
    const adjustInitData = {
        id: serviceRequest.id,
        adjustedRequestCloseDate: serviceRequest.adjustedRequestCloseDate,
        adjustDescription: serviceRequest.adjustDescription,
    };
    const transferInitData = {
        id: serviceRequest.id,
        transferer: serviceRequest.transferer,
        transfererId: serviceRequest.transfererId,
        transferDescription: serviceRequest.transferDescription,
    }
    const rejectInitData = {
        id: serviceRequest.id, rejectDescription: serviceRequest.rejectDescription
    }
    const examineInitData = {id: serviceRequest.id, examineType: "",};
    const [adjust, setAdjust] = useState(adjustInitData)
    const [transfer, setTransfer] = useState(transferInitData);
    const [reject, setReject] = useState(rejectInitData)
    const [examineData, setExamineData] = useState(examineInitData);

    const {t} = useTranslation();

    const progressStatusValue = useSelector(state => state.content.progressStatusValue);
    const statusNumericValue = useSelector(state => state.content.statusNumericValue);
    const dispatch = useDispatch();

    const getExamineTypeOptions = () => {
        return ExamineRadioAttributes.map((attribute) => {
            const next = {...attribute};

            if (attribute.value === ExamineType.ADJUST) {
                next.disable = Boolean(serviceRequest.adjustedRequestCloseDate);
            }
            if (attribute.value === ExamineType.TRANSFER) {
                next.disable = Boolean(serviceRequest.transfererId);
            }
            if (attribute.value === ExamineType.REJECT) {
                next.disable = progressStatusValue.rejected === ContentStatus.REJECT.statusValue;
            }

            return next;
        });
    };

    const buildExamineTypeSelectOptions = () => {
        return [
            {id: EXAMINE_TYPE_PLACEHOLDER_ID, name: "선택"},
            ...getExamineTypeOptions()
                .filter((option) => !option.disable)
                .map((option) => ({
                    id: EXAMINE_TYPE_OPTION_IDS[option.value],
                    name: option.text,
                })),
        ];
    };

    const handleExamineTypeSelectChange = (selectedId) => {
        if (selectedId === EXAMINE_TYPE_PLACEHOLDER_ID || selectedId == null) {
            handleResetInput();
            return;
        }
        const examineType = EXAMINE_TYPE_ID_TO_VALUE[selectedId];
        if (examineType) {
            setExamineData((prev) => ({...prev, examineType}));
        }
    };

    const handleSaveExamine = async (examineType) => {
        if (examineType === ExamineType.ADJUST) {
            const data = {
                id: serviceRequest.id,
                examineType: ExamineType.ADJUST,
                adjustedRequestCloseDate: adjust.adjustedRequestCloseDate,
                adjustDescription: adjust.adjustDescription,
            }
            if (!handleValidation(data.adjustedRequestCloseDate, "조정일을 선택해주세요.")) return;
            if (!handleValidation(data.adjustDescription, "조정 사유을 작성해주세요.")) return;
            if (window.confirm(t(`confirmSave`))) {
                const response = await updateAdjustOnExamine(data);
                if (response && response.status === 200) {
                    handleActiveToast({message: "마감일이 조정되었습니다."});
                    dispatch(changeRefreshContentStatus());
                    setExamineData((prev) => ({...prev, examineType: ""}));
                }
            }
        } else if (examineType === ExamineType.TRANSFER) {
            const data = {
                id: serviceRequest.id,
                examineType: ExamineType.TRANSFER,
                ...transfer,
            }
            if (!handleValidation(data.transfererId, "이관자를 선택해주세요.")) return;
            if (!handleValidation(data.transferDescription, "이관 사유를 작성해주세요.")) return;
            if (window.confirm(t(`confirmSave`))) {
                const response = await updateTransferOnExamine(data);
                if (response && response.status === 200) {
                    handleActiveToast({message: "업무가 이관되었습니다."});
                    dispatch(changeRefreshContentStatus());
                    setExamineData((prev) => ({...prev, examineType: ""}));
                }
            }
        } else if (examineType === ExamineType.REJECT) {
            const data = {
                id: serviceRequest.id,
                examineType: ExamineType.REJECT,
                rejectDescription: reject.rejectDescription
            }
            if (!handleValidation(data.rejectDescription, "반려 사유를 작성해주세요.")) return;
            if (window.confirm(t(`confirmSave`))) {
                const response = await updateRejectOnExamine(data);
                if (response && response.status === 200) {
                    handleActiveToast({message: "접수가 반려되었습니다."});
                    dispatch(changeRefreshContentStatus());
                    setExamineData((prev) => ({...prev, examineType: ""}));
                }
            }
        }
    }

    const handleModification = async (value, target) => {
        if (target === 'adjustedRequestCloseDate' || target === 'adjustDescription') {
            const data = {...adjust, [target]: value, modification: true};
            const response = await updateAdjustOnExamine(data);
            if (response && response.status === 200) {
                setAdjust({...data, modification: false});
                handleActiveToast({message: t(`updated`)});
            }
        } else if (target === 'rejectDescription') {
            const data = {...reject, [target]: value, modification: true};
            const response = await updateRejectOnExamine(data);
            if (response && response.status === 200) {
                setReject({...data, modification: false});
                handleActiveToast({message: t(`updated`)});
            }
        } else if (target === 'transferDescription' || target === 'transfererId') {
            const data = {...transfer, [target]: value, modification: true};
            const response = await updateTransferOnExamine(data);
            if (response && response.status === 200) {
                setTransfer((prev) => ({
                    ...prev,
                    modification: false
                }))
                handleActiveToast({message: t(`updated`)});
            }
        }
    }

    const handleChangeNextStatus = async () => {
        if (window.confirm(t(`changeNextStep`))) {
            const data = {
                id: serviceRequest.id,
                transfererId: serviceRequest.transfererId,
                modification: false
            }
            const serviceResponse = await updateExamineCloseDate(data);
            if (serviceResponse && serviceResponse.status === 200) {
                dispatch(changeRefreshContentStatus());
                handleActiveToast({message: t(`examineComplete`)});

                const response = await changeNextContentStatus({
                    contentId: serviceRequest.id,
                    contentCategory: ContentCategory.SERVICE_REQUEST
                });
                if (response && response.status === 200) {
                    dispatch(changeStatusNumericValue(0));
                }
            } else {
                handleActiveToast({message: "서버에러"});
            }
        }
    }

    const handleResetInput = () => {
        setAdjust(adjustInitData);
        setTransfer(transferInitData);
        setReject(rejectInitData);
        setExamineData(examineInitData)
    }

    const showExamineResult = () => {
        return serviceRequest.adjustedRequestCloseDate || serviceRequest.transfererId
            || (progressStatusValue.rejected === ContentStatus.REJECT.statusValue)
            || serviceRequest.examineCloseDate
            || statusNumericValue === ContentStatus.EXAMINE.statusNumericValue;
    }

    const showExamineInput = () => {
        // 권한에 따른 인풋 활성화
        return serviceRequest.rudAuthDto.update;
    }

    return (
        <>
            {/* 검토 종료시 표시됨 */}
            {serviceRequest.examineCloseDate && showExamineResult() &&
                <DetailPanel title={"검토관리"}>
                    <DetailKvTable>
                        <tbody>
                        {statusNumericValue > ContentStatus.EXAMINE.statusNumericValue &&
                            <>
                                <tr>
                                    <Th_title title={"검토 종료일"} className="fieldset-td" colspan={3}>
                                        <div>{serviceRequest.examineCloseDate}</div>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title={"검토"} className="fieldset-td" colspan={3}>
                                        <div>{serviceRequest.examineCloseUser?.name}</div>
                                    </Th_title>
                                </tr>
                                {serviceRequest.adjustedRequestCloseDate &&
                                    <tr>
                                        <Th_title title={"조정정보"} className="fieldset-td" colspan={3}>
                                            <div>{`조정일 : ${serviceRequest.adjustedRequestCloseDate}`}</div>
                                            <div className={"w-[70vw] mt-2"}>{serviceRequest.adjustDescription}</div>
                                        </Th_title>
                                    </tr>
                                }
                                {serviceRequest.transfererId &&
                                    <tr>
                                        <Th_title title={"이관정보"} className="fieldset-td" colspan={3}>
                                            <div>{`이관 담당자 : ${serviceRequest.transferer.department ? `[${serviceRequest.transferer.department.name}]` : ''} ${serviceRequest.transferer.name}`}</div>
                                            <div className={"mt-2"}>{serviceRequest.transferDescription}</div>
                                        </Th_title>
                                    </tr>
                                }
                            </>
                        }

                        {/* 반려시 저장된 조정, 이관 정보를 보여준다. */}
                        {progressStatusValue.rejected === ContentStatus.REJECT.statusValue && (
                            <>
                                {serviceRequest.adjustedRequestCloseDate && (
                                    <tr>
                                        <Th_title title={"조정정보"} className="fieldset-td" colspan={3}>
                                            <div>{`조정일 : ${serviceRequest.adjustedRequestCloseDate}`}</div>
                                            <div className={"w-[70vw] mt-2"}>{serviceRequest.adjustDescription}</div>
                                        </Th_title>
                                    </tr>
                                )}
                                {serviceRequest.transfererId && (
                                    <tr>
                                        <Th_title title={"이관정보"} className="fieldset-td" colspan={3}>
                                            <div>{`이관 담당자 : ${serviceRequest.transferer.department ? `[${serviceRequest.transferer.department.name}]` : ''} ${serviceRequest.transferer.name}`}</div>
                                            <div className={"mt-2"}>{serviceRequest.transferDescription}</div>
                                        </Th_title>
                                    </tr>
                                )}
                                <tr>
                                    <Th_title title={"반려정보"} className="fieldset-td" colspan={3}>
                                        <div>{`반려자 : ${progressStatusValue.rejectUser.department ? `[${progressStatusValue.rejectUser.department.name}]` : ''} ${progressStatusValue.rejectUser.name}`}</div>
                                        <div className={"mt-2"}>{progressStatusValue.description}</div>
                                    </Th_title>
                                </tr>
                            </>
                        )}
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            }

            {!serviceRequest.examineCloseDate && showExamineInput() &&
                statusNumericValue === ContentStatus.EXAMINE.statusNumericValue &&
                !(progressStatusValue.rejected === ContentStatus.REJECT.statusValue) &&
                <DetailPanel title={"검토관리"} className="service-request-examine-panel">
                    <DetailKvTable>
                        <tbody>
                        <>
                            <tr>
                                <Th_title title={"검토 유형"} className="fieldset-td" colspan={3}>
                                    <div className="service-request-examine-type-row">
                                        <SimmsSelect
                                            options={buildExamineTypeSelectOptions()}
                                            data={
                                                examineData.examineType
                                                    ? EXAMINE_TYPE_OPTION_IDS[examineData.examineType]
                                                    : EXAMINE_TYPE_PLACEHOLDER_ID
                                            }
                                            onChange={handleExamineTypeSelectChange}
                                        />
                                        <DetailSummaryButton onClick={handleChangeNextStatus}>
                                            검토완료
                                        </DetailSummaryButton>
                                    </div>
                                </Th_title>
                            </tr>
                            {serviceRequest.adjustedRequestCloseDate && (
                                <>
                                    <tr>
                                        <Th_title title={"조정일"} className="fieldset-td" colspan={3} required={true} auth>
                                            <SimmsDatePicker onChange={(v)=> dateOnChange(setAdjust,"adjustedRequestCloseDate", v, true)}
                                                             update onUpdate={(v)=> handleModification(v, "adjustedRequestCloseDate")}
                                                             data={adjust.adjustedRequestCloseDate}
                                                             constraint={{largerThan : serviceRequest.requestCloseDate && dayjs(serviceRequest.requestCloseDate)}}/>
                                        </Th_title>
                                    </tr>
                                    <tr>
                                        <Th_title title={"조정 내용"} className="fieldset-td" colspan={3} auth>
                                            <SimmsTextArea onChange={(v)=>inputOnChange(setAdjust,"adjustDescription", v, false)}
                                                           update
                                                           style={{maxHeight:'200px', minHeight: "80px", height: '100%'}}
                                                           onKeyDown={(v,e)=> handleModification(v, "adjustDescription", e)}
                                                           data={adjust.adjustDescription}/>
                                        </Th_title>
                                    </tr>
                                </>
                            )}
                            {serviceRequest.transfererId && (
                                <>
                                    <tr>
                                        <Th_title title={"이관 담당자"} className="fieldset-td" colspan={3}>
                                            <Selector
                                                onChange={(value)=> onUpdate(
                                                        setTransfer, UserType.transferer, UserIdType.transfererId,
                                                        transfer.transferer, value, handleModification
                                                    )
                                                }
                                                data={transfer.transferer}
                                                uniqueKey={UserType.transferer}
                                                entity={"userAccount"} auth
                                            >

                                                <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                            </Selector>
                                        </Th_title>
                                    </tr>
                                    <tr>
                                        <Th_title title={"이관 내용"} className="fieldset-td" colspan={3} auth>
                                            <SimmsTextArea onChange={(v)=> inputOnChange(setTransfer,"transferDescription", v, false)}
                                                           update
                                                           // style={{minHeight:'120px'}}
                                                           onKeyDown={(v,e)=> handleModification(v, "transferDescription", e)}
                                                           data={transfer.transferDescription}/>
                                        </Th_title>
                                    </tr>
                                </>
                            )}

                            {/* 검토 유형 선택 후 — 필드별 KV 행 (TaskManager 패턴) */}
                            {examineData.examineType === ExamineType.ADJUST && (
                                <>
                                    <tr>
                                        <Th_title title={"조정일"} className="fieldset-td" colspan={3} required auth>
                                            <SimmsDatePicker
                                                onChange={(v) => dateOnChange(setAdjust, "adjustedRequestCloseDate", v, true)}
                                                data={adjust.adjustedRequestCloseDate}
                                                constraint={{
                                                    largerThan: serviceRequest.requestCloseDate && dayjs(serviceRequest.requestCloseDate),
                                                    required: true,
                                                }}
                                                auth
                                            />
                                        </Th_title>
                                    </tr>
                                    <tr className="asset-detail-kv-row--auto">
                                        <Th_title title={"조정 사유"} className="fieldset-td" colspan={3} required auth>
                                            <div className="detail-kv-field-stack">
                                                <div className="detail-kv-field-stack__input">
                                                    <TextAreaBasic
                                                        target={"adjustDescription"}
                                                        placeholder={"마감일 조정 사유를 작성해주세요."}
                                                        required
                                                        data={{data: adjust, setData: setAdjust}}
                                                    />
                                                </div>
                                                <div className="detail-kv-actions">
                                                    <div className="detail-kv-actions__hint is-empty" aria-hidden="true" />
                                                    <div className="detail-kv-actions__buttons">
                                                        <DetailSummaryButton onClick={() => handleSaveExamine(ExamineType.ADJUST)}>
                                                            조정하기
                                                        </DetailSummaryButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </Th_title>
                                    </tr>
                                </>
                            )}
                            {examineData.examineType === ExamineType.TRANSFER && (
                                <>
                                    <tr>
                                        <Th_title title={"이관 담당자"} className="fieldset-td" colspan={3} required auth>
                                            <Selector
                                                onChange={(value) => onCreateIdClickListener(
                                                    setTransfer, UserType.transferer, UserIdType.transfererId, transfer.transferer, value
                                                )}
                                                data={transfer.transferer}
                                                uniqueKey={UserType.transferer}
                                                entity={"userAccount"}
                                                constraint={{required: true}}
                                                auth
                                            >
                                                <SimmsInputSearch type={"TEXT"} placeHolder={"사용자명"} />
                                                <SimmsDrawerSearch showLabel title={"부서"} entity={"department"} target={"department"} recursive />
                                                <SimmsDrawerSearch showLabel title={"업체"} entity={"company"} target={"company"} />
                                            </Selector>
                                        </Th_title>
                                    </tr>
                                    <tr className="asset-detail-kv-row--auto">
                                        <Th_title title={"이관 사유"} className="fieldset-td" colspan={3} required auth>
                                            <div className="detail-kv-field-stack">
                                                <div className="detail-kv-field-stack__input">
                                                    <TextAreaBasic
                                                        target={"transferDescription"}
                                                        placeholder={"업무 이관 사유를 작성해주세요."}
                                                        required
                                                        data={{data: transfer, setData: setTransfer}}
                                                    />
                                                </div>
                                                <div className="detail-kv-actions">
                                                    <div className="detail-kv-actions__hint is-empty" aria-hidden="true" />
                                                    <div className="detail-kv-actions__buttons">
                                                        <DetailSummaryButton onClick={() => handleSaveExamine(ExamineType.TRANSFER)}>
                                                            이관하기
                                                        </DetailSummaryButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </Th_title>
                                    </tr>
                                </>
                            )}
                            {examineData.examineType === ExamineType.REJECT && (
                                <tr className="asset-detail-kv-row--auto">
                                    <Th_title title={"반려 사유"} className="fieldset-td" colspan={3} required auth>
                                        <div className="detail-kv-field-stack">
                                            <div className="detail-kv-field-stack__input">
                                                <TextAreaBasic
                                                    target={"rejectDescription"}
                                                    required
                                                    data={{data: reject, setData: setReject}}
                                                />
                                            </div>
                                            <div className="detail-kv-actions">
                                                <div className="detail-kv-actions__hint is-empty" aria-hidden="true" />
                                                <div className="detail-kv-actions__buttons">
                                                    <DetailSummaryButton danger onClick={() => handleSaveExamine(ExamineType.REJECT)}>
                                                        반려하기
                                                    </DetailSummaryButton>
                                                </div>
                                            </div>
                                        </div>
                                    </Th_title>
                                </tr>
                            )}
                        </>
                        </tbody>
                    </DetailKvTable>
                </DetailPanel>
            }
        </>
    );
};

export default ServiceRequestExamine;